import { render, staticRenderFns } from "./showMoreCatalog.vue?vue&type=template&id=571f16cd&scoped=true"
import script from "./showMoreCatalog.vue?vue&type=script&lang=js"
export * from "./showMoreCatalog.vue?vue&type=script&lang=js"
import style0 from "./showMoreCatalog.vue?vue&type=style&index=0&id=571f16cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571f16cd",
  null
  
)

export default component.exports